import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()

export class RiskEvalCategoryService {

    constructor(private http: HttpClient) {

    }

    getEvaluationCategoryList(): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationCriteriaList')
            .toPromise()
            .then(response => {
                return Promise.resolve(response)
            })
    }

    addEvaluation(evaluationDatalist): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/addEvaluationCriteria', evaluationDatalist)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

    getEvaluationTypeList() : Promise<any>{
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/getEvaluationTypeList')
        .toPromise()
        .then(response => {
            return Promise.resolve(response)
        })
    }

    updateEvaluationCategory(updatedEvaluation): Promise<any> {
        return this.http.post(environment.clientUrl + 'riskEvaluationMaster/updateEvaluationCriteria' , updatedEvaluation)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }


    deleteEvaluation(evalId): Promise<any> {
        return this.http.get(environment.clientUrl + 'riskEvaluationMaster/deleteEvaluationCriteria?evaluationCriteriaID=' + evalId)
            .toPromise()
            .then(response => {
                return Promise.resolve(response);
            })
    }

}